import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className="container container-fluid footer" style={{textAlign: 'right', color: '#2D62ED', marginBottom: '0.5%'}}>
            <img src="./images/logo.svg" alt="logo" height="22px" />&nbsp;&nbsp;&nbsp;Beyond Static
        </div>
    )
}
